import { Component } from '@angular/core';
import { SelectTemplate } from 'src/app/@amiga-pyme/select/templates/select.template';
import { IProvider, PROVIDER_TTL_ES } from '../../provider.interface';
import { ProviderService } from '../../provider.service';

@Component({
  selector: 'pg-provider-select',
  template: `
    <ami-select
      [settings]="table.settings"
      [data]="table.data"
      (selectedRowsEvent)="onReciveSelectedRows($event)"
    ></ami-select>
  `
})
export class ProviderSelectComponent extends SelectTemplate {
  constructor(private serviceBase: ProviderService) {
    super(PROVIDER_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.table.settings = {
      title: PROVIDER_TTL_ES,
      columns: [
        { header: 'RUC', field: 'ruc' },
        { header: 'Nombre', field: 'name' },
        { header: 'Dirección', field: 'address' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IProvider[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
